import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { api } from "../lib/api";

const SettingsContext = createContext(null);
const CategoriesContext = createContext(null);

const DEFAULT_SETTINGS = {
    contact_email: "hola@luzdeangely.com",
    instagram: "luzdeangely",
    whatsapp_number: "",
    whatsapp_message: "¡Hola! Me gustaría más información sobre tus joyas ✨",
    address: "",
    city: "",
    free_shipping_threshold: 50,
    welcome_coupon: "BIENVENIDA10",
    brand_tagline: "Bisutería artesanal hecha con amor",
    hero_main_image: "",
    hero_secondary_image: "",
    hero_overline: "· Colección Primavera ·",
    hero_title: "Joyas que susurran tu historia.",
    hero_subtitle: "Bisutería artesanal hecha pieza a pieza, con materiales nobles y un toque romántico. Encuentra el detalle que te define.",
};

export function StoreDataProvider({ children }) {
    const [settings, setSettings] = useState(DEFAULT_SETTINGS);
    const [categories, setCategories] = useState([]);
    const [loaded, setLoaded] = useState(false);

    const reloadSettings = useCallback(async () => {
        try {
            const { data } = await api.get("/settings");
            setSettings({ ...DEFAULT_SETTINGS, ...data });
        } catch {
            setSettings(DEFAULT_SETTINGS);
        }
    }, []);

    const reloadCategories = useCallback(async () => {
        try {
            const { data } = await api.get("/categories");
            setCategories(data);
        } catch {
            setCategories([]);
        }
    }, []);

    useEffect(() => {
        Promise.all([reloadSettings(), reloadCategories()]).finally(() => setLoaded(true));
    }, [reloadSettings, reloadCategories]);

    const settingsValue = useMemo(
        () => ({ settings, reloadSettings, loaded }),
        [settings, reloadSettings, loaded]
    );
    const categoriesValue = useMemo(
        () => ({ categories, reloadCategories }),
        [categories, reloadCategories]
    );

    return (
        <SettingsContext.Provider value={settingsValue}>
            <CategoriesContext.Provider value={categoriesValue}>
                {children}
            </CategoriesContext.Provider>
        </SettingsContext.Provider>
    );
}

export function useSettings() {
    const ctx = useContext(SettingsContext);
    if (!ctx) throw new Error("useSettings must be inside StoreDataProvider");
    return ctx;
}

export function useCategories() {
    const ctx = useContext(CategoriesContext);
    if (!ctx) throw new Error("useCategories must be inside StoreDataProvider");
    return ctx;
}
